import { Card, Checkbox, Layout, Paragraph, ShowMore, Button } from "@vwfs-bronson/bronson-react";
import { IMatchMakerAnswers, ISelectListItem } from "../../interfaces";
import React from "react";
import { AdditionalProductType, VehicleOptionType } from "@bus/models";

type Props = {
    defaultOption?:
    | "1/1"
    | "1/3"
    | "2/3"
    | "3/3"
    | "1/2"
    | "2/2"
    | "1/4"
    | "2/4"
    | "3/4"
    | "4/4"
    | "1/5"
    | "2/5"
    | "3/5"
    | "4/5"
    | "5/5"
    | "1/6"
    | "2/6"
    | "3/6"
    | "4/6"
    | "5/6"
    | "6/6"
    | "1/12"
    | "2/12"
    | "3/12"
    | "4/12"
    | "5/12"
    | "6/12"
    | "7/12"
    | "8/12"
    | "9/12"
    | "10/12"
    | "11/12"
    | "12/12";
    item: ISelectListItem<AdditionalProductType | VehicleOptionType | string>;
    handleOnChange: (e: AdditionalProductType | VehicleOptionType | string) => void;
    values: IMatchMakerAnswers;
    fieldName: keyof IMatchMakerAnswers;
    className?: string;
};

export const CheckboxCustom: React.FC<Props> = ({ defaultOption, item, values, handleOnChange, fieldName, className }) => {
    return (
        <Layout.Item className={className} default={defaultOption ? defaultOption : "1/2"}>
            {item.tooltip && (
                <Card
                    expandable
                    title={item.displayName}
                    titleLevel={3}
                    subtitle={
                        <ShowMore labelExpand="Dettagli" labelCollapse="Dettagli">
                            <Paragraph aria-labelledby={`${fieldName}_${item.id}`}>{item.tooltip}</Paragraph>
                            {item.textLink && <Paragraph aria-labelledby={`${fieldName}_${item.id}`}>
                                {item.textLink?.split('qui')[0]}
                                <a aria-label={item?.ariaLabel as string} href={item.link} target="_blank">qui</a>
                                {item.textLink?.split('qui')[1]}
                            </Paragraph>}
                        </ShowMore>
                    }
                    id={`${fieldName}_${item.id}`}
                    contentShort={
                        <Checkbox
                            name={fieldName}
                            onChange={(e) => handleOnChange(e.target.value)}
                            id={`${fieldName}_${item.id}`}
                            checked={((values[fieldName] as (string | number | boolean)[]) || [])?.includes(item.value)}
                            value={item.value}

                        >
                        </Checkbox>
                    }>

                </Card>)
            }
            {!item.tooltip && (
                <Checkbox
                    name={fieldName}
                    onChange={(e) => handleOnChange(e.target.value)}
                    id={`${fieldName}_${item.id}`}
                    checked={((values[fieldName] as (string | number | boolean)[]) || [])?.includes(item.value)}
                    value={item.value}
                >
                    {item.displayName}
                </Checkbox>)
            }

        </Layout.Item>
    );
};

export default CheckboxCustom;
